import React from "react";
import "./ExpCard.scss"

const ExpCard = ({ experience }) => {
    return (
        <div className="ExpCard" style={{ background: experience?.bgColor }}>
            <div className="ExpCard-iconcont" style={{ background: experience?.iconBgColor }}>
                <img alt="" src={experience?.icon} />
            </div>
            <div className="ExpCard-header">
                {experience?.header}
            </div>
            <div className="ExpCard-subheader">
                {experience?.subheader}
            </div>
        </div>
    )
}
export default ExpCard